const DeleteButton = ({item, onDelete}) => {

    return (
        <button
            type="button"
            className="delete-btn"
            onClick={() => onDelete(item)}
        >
            X
        </button>
    )
}

export default DeleteButton